export default __webpack_public_path__ + "static/media/blog_1.15b1097f.jpg";